export function shouldRestashFailedPresentationCommit(input: {
  expectedFrames: ReadonlyArray<{ id: string }>
  expectedViewIdx: number
  surfaceFrames: ReadonlyArray<{ id: string }>
  surfaceViewIdx: number
}): boolean {
  if (input.expectedFrames.length === 0) {
    return false
  }
  const expectedVis = input.expectedFrames[
    Math.min(Math.max(0, input.expectedViewIdx), input.expectedFrames.length - 1)
  ]
  if (expectedVis == null || expectedVis.id === '') {
    return false
  }
  const surfaceVis = input.surfaceViewIdx >= 0
    && input.surfaceViewIdx < input.surfaceFrames.length
    ? input.surfaceFrames[input.surfaceViewIdx]
    : undefined
  return surfaceVis?.id !== expectedVis.id
}
